export default __webpack_public_path__ + "static/media/stocktaking2.7037d6f1.jpg";